<template>
  <div class="container">

        <div class="py-3">
          <div class="project">
              <div class="row mb-3 mb-md-0">
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <input
                      id="title"
                      type="title"
                      placeholder="Name your project"
                      class="form-control"
                      name="title"
                      v-model="project.title"/>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <select class="form-select" v-model="project.category">
                      <option value="0" disabled selected hidden>
                        Choose project type
                      </option>
                      <option
                        v-for="(category, index) in categories"
                        :key="index"
                        :value="category.id">
                        {{ category.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-12 col-md-3">
                  <select class="form-select" v-model="project.budget">
                    <option value="0" disabled selected hidden>Budget</option>
                    <option
                      v-for="(budget, index) in budgets"
                      :key="index"
                      :value="budget.value">
                      {{ budget.name }}
                    </option>
                  </select>
                </div>
              </div>
              <textarea
                class="form-control shadow-none inputbox"
                rows="10"
                placeholder="Describe your project here"
                v-model="project.description"></textarea>

              <div class="mb-2 mt-3">
                <button
                  v-if="!sending"
                  @click="createProject"
                  type="button"
                  class="btn btn-danger py-1 shadow-none col py-2">
                  Create Project
                </button>

                <button
                  v-else
                  type="button"
                  class="btn btn-success py-1 shadow-none col py-2">
                  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
               </div>
          </div>
        </div>
      </div>
</template> 

<script>
import "vue-select/dist/vue-select.css";

export default {

  data() {
    return {
      project: {
        title: '',
        category: 0,
        budget: 0,
        description: '',
      },
      sending: false,
      creating: false,
      sent: false,
      categories: [],
      budgets: [],
      loading_categories: false,
    };
  },

  created() {
    this.getCategories();
    this.populateBudgets();
  },

  methods: {
    populateBudgets() {
      let start = 50;
      let end = 20000;
      let increment = 10;

      for (var i = start; i <= end; i += increment) {
        var row = { value: i, name: this.formattedPrice(i) };
        this.budgets.push(row);
      }
    },

    getCategories() {
      this.loading_categories = true;

      axios.get('/categories/services').then((response) => {
        this.categories = response.data;
        this.loading_categories = false;
      });
    },

    createProject() {
      if (this.project.title == '') {
        this.sweetfire("Please enter a name for your project");
      } else if (this.project.category == 0) {
        this.sweetfire("Please choose a project type");
      } else if (this.project.budget == 0) {
        this.sweetfire("Please select a budget for your project");
      } else if (this.project.description == '') {
        this.sweetfire("Please describe you project requirements");
      } else {
        console.log(this.project)
        this.$emit('create-project', this.project);
      }
    },

    sweetfire(text) {
      Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: "Ok",
        customClass: {
          title: "popup-title",
        },
      });
    },
  },
};
</script>

<style scoped>
.project {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
  background-color: #272c35;
  border-radius: 20px;
  color: #fff;
}

input.form-control,
input.form-control:focus {
  padding: 0.35rem 1.6rem;
  background-color: #fff;
  color: #111;
  border-radius: 5px !important;
  font-size: 1rem;
  border: none !important;
}

.btn { border-radius: 5px !important; }

select.form-select { background: white; }
textarea.form-control { border: none !important; }
</style>